import axios from '@/axios'

export default {
  fetchAll(params, id){
    return axios.get(`/transfer-details/all/${id}`, {params})
  },
  fetchLimit(params, id){
    return axios.get(`/transfer-details/limit/${id}`, {params})
  },  
  fetchById(id){
    return axios.get(`/transfer-details/${id}`)
  },    
  create(payload){
    return axios.post(`/transfer-details`, payload)
  },
  update(id, payload){
    return axios.put(`/transfer-details/${id}`, payload)
  },
  delete(id){
    return axios.delete(`/transfer-details/${id}`)
  }, 
  deleteMultiple(payload){
    return axios.delete(`/transfer-details`, payload)
  }
}